module.exports = __webpack_public_path__ + "img/icon33.46382a99.png";